import { PhysicalInfoSearchDto } from '@app/api2/api';
import * as Yup from 'yup';

export const PhysicalSearchSchema: Yup.SchemaOf<PhysicalInfoSearchDto> = Yup.object({
    discriminator: Yup.string().required(),
    operator: Yup.string().optional(),
    eyeColor: Yup.number().optional().nullable().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { hairColor, height, weight } = this.parent;
            return !!value || !!hairColor || !!height || !!weight;
        }
    ),
    hairColor: Yup.number().optional().nullable().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { eyeColor, height, weight } = this.parent;
            return !!value || !!eyeColor || !!height || !!weight;
        }
    ),
    height: Yup.number().optional().nullable().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { eyeColor, hairColor, weight } = this.parent;
            return !!value || !!eyeColor || !!hairColor || !!weight;
        }
    ),
    weight: Yup.number().optional().nullable().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { eyeColor, hairColor, height } = this.parent;
            return !!value || !!eyeColor || !!hairColor || !!height;
        }
    ),
});
